/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { i as isFunction_1 } from '../../_chunks/dep-97c71289.mjs';
import { i as isString_1 } from '../../_chunks/dep-5f6c8826.mjs';
import '../../_chunks/dep-6f3e4f56.mjs';
import '../../_chunks/dep-b1060562.mjs';
import '../../_chunks/dep-b333ab93.mjs';
import '../../_chunks/dep-4efc69ee.mjs';
import '../../_chunks/dep-0d1bd08c.mjs';
import '../../_chunks/dep-c5d88cfe.mjs';
import '../../_chunks/dep-8049d2e0.mjs';

function getTargetElm(elm) {
  if (elm) {
    var _process;
    var targetElement = null;
    if (isString_1(elm)) {
      targetElement = document.querySelector(elm);
    } else if (isFunction_1(elm)) {
      targetElement = elm();
    } else {
      throw new Error("elm should be string or function");
    }
    if (targetElement) {
      return targetElement;
    }
    if (((_process = process) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.NODE_ENV) !== "test") {
      throw new Error("There is no element with given.");
    }
  } else {
    return document.body;
  }
}

export { getTargetElm as default };
//# sourceMappingURL=getTargetElm.mjs.map
